<template>
	<button class="reset">
		<svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" fill="none" viewBox="0 0 13 12" class="pointer-events-none">
			<g :class="strokeAsc" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
				<path d="m1 3 2-2 2 2M3 11V1"/>
			</g>
			<g :class="strokeDesc" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
				<path d="m12 9-2 2-2-2M10 1v10"/>
			</g>
		</svg>
	</button>
</template>
  
<script>
export default {
	name: 'OrderButton',
	props: ['active', 'order'],
	computed: {
		strokeAsc() {
			return this.active && this.order.toLowerCase() == 'asc' ? 'color-violet' : 'color-gray-50';
		},
		strokeDesc() {
			return this.active && this.order.toLowerCase() == 'desc' ? 'color-violet' : 'color-gray-50';
		},
	}
};
</script>
  
